/* 
Menu Types:
"menu-default", "menu-sub-hidden", "menu-hidden"
*/
export const defaultMenuType = "menu-default";

export const subHiddenBreakpoint = 1440;
export const menuHiddenBreakpoint = 768;
export const defaultLocale = "en";

/* Color Options: "light.purple", "dark.purple" */
export const defaultColor = "light.green";
export const isDarkSwitchActive = true;
export const themeColorStorageKey="__theme_color";
export const isDemo = true;